import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Converts a MySQL date string (in GMT-2) to Hong Kong time zone (Asia/Hong_Kong, +08:00)
 * @param {string} mysqlDate - Date string from MySQL (e.g. '2025-09-17 12:00:00')
 * @returns {string} - Date string in HK time zone
 */
export function toHongKongTime(mysqlDate) {
  // Append GMT-2 offset to the date string
  const gmt2Date = dayjs.tz(mysqlDate + "-02:00", "Etc/GMT+2");
  // Convert to HK time zone
  return gmt2Date.tz("Asia/Hong_Kong").format("YYYY-MM-DD HH:mm:ss");
}

// Example usage:
// const hkDate = toHongKongTime('2025-09-17 12:00:00');
// console.log(hkDate); // Date in HK time zone
